//=require ../utils.js

class FP_Blog_Post {
	constructor() {
		this.commentButtonClass = 'submit-comment-button';
		
		window.FirePluginsV2InvisibleReCaptcha = this.reCAPTCHACallback;

		this.initEvents();
	}

	reCAPTCHACallback() {
		if (!window.grecaptcha) {
			return;
		}
		
		let recaptcha = document.querySelector('.post-recaptcha');
		if (!recaptcha) {
			return;
		}

		const form = recaptcha.closest('.comment-form');
		const options = {
			badge: recaptcha.dataset.badge,
			callback: function() {
				form.querySelector('input[type="submit"]').click();
			},
			sitekey: recaptcha.dataset.sitekey,
			size: 'invisible'
		};

		const widgetID = grecaptcha.render(recaptcha, options);
		recaptcha.setAttribute('data-recaptcha-widget-id', widgetID);

		// Invoke the reCAPTCHA check when the user submits the form
		form.addEventListener('beforeSubmit', function(e) {
			if (e.defaultPrevented) {
				return;
			}

			const response = grecaptcha.getResponse(widgetID);

			// Do not proceed if the widget is already verified, 
			if (response.length > 0) {
				return;
			}

			e.preventDefault();

			grecaptcha.execute(widgetID);
		});

		// Reset the widget after the form is submitted
		form.addEventListener('afterSubmit', function(e) {
			grecaptcha.reset(widgetID);
		});
	}

	initEvents() {
		document.addEventListener('click', e => {
			this.submitCommentForm(e);
		});

		this.onBannerUpdate();
		window.addEventListener('scroll', e => {
			this.onBannerUpdate();
		});
	}

	onBannerUpdate() {
		let banner = document.querySelector('.blog-post-banner');
		if (!banner) {
			return;
		}
		
		var top  = window.pageYOffset || document.documentElement.scrollTop;

		if (top > 50) {
			banner.classList.add('is-visible');
		} else {
			banner.classList.remove('is-visible');
		}
	}

	/**
	 * Submit commect.
	 * 
	 * @param   {Event}  e 
	 * 
	 * @return  void
	 */
	submitCommentForm(e) {
		let btn = e.target.closest('.' + this.commentButtonClass);
		if (!btn) {
			return;
		}

		e.preventDefault();

		let form = btn.closest('form');

		if (form.classList.contains('is-working')) {
			return;
		}

		// set loading state
		btn.closest('p').classList.add('loading');
		
		// Submit form
		let event = form.dispatchEvent(new CustomEvent('beforeSubmit', { cancelable: true }));
		if (!event) {
			return;
		}
		
		// grab form data
		let data = new FormData(form);
		let dataNew = new FormData();
		for (let [key, value] of data) {
			const el = form.querySelector('[name="' + key + '"]');
			dataNew.append(key, value);
		}
		dataNew.append('action', 'post_ajax_comment');
		
		// make ajax request
		fetch(fireplugins.ajax_url,
		{
			method: "POST",
			body: dataNew
		})
		.then(function(res){ return res.json(); })
		.then(function(data){
			// Show error message
			if (data.error) {
				form.querySelector('.comments-errors').innerHTML = data.response;
				form.querySelector('.comments-errors').classList.add('visible');

				// Remove loading state
				btn.closest('p').classList.remove('loading');

				form.dispatchEvent(new CustomEvent('afterSubmit', { cancelable: true }));

				return;
			}
			
			// Hide error message
			form.querySelector('.comments-errors').classList.remove('visible');
			
			const comments = btn.closest('#comments');
			const commentRespond = btn.closest('.comment-respond');
			const commentsList = comments.querySelector('.comment-list');

			if (!commentsList) {
				comments.querySelector('.no-comments-message').remove();
				
				let commentsList = document.createElement('ol');
				commentsList.classList.add('comment-list');
				commentsList.innerHTML = data.comment;

				comments.insertBefore(commentsList, comments.querySelector('.comment-respond'));
			} else {
				/**
				 * If we are adding a reply, this is the comment we are adding a reply to
				 * 
				 * If we are adding a base comment, this is the HTMLElement where all comments are stored.
				 */
				const prevElement = commentRespond.previousElementSibling;
				
				const addingReply = !prevElement.classList.contains('comment-list');
				if (addingReply) {
					let isChildren = commentRespond.closest('.children');
					
					// Adding a reply within a children comment
					if (isChildren) {
						// Adding a second child reply to existing replies
						if (commentRespond.nextElementSibling && commentRespond.nextElementSibling.classList.contains('children')) {
							commentRespond.nextElementSibling.innerHTML += data.comment;
						// Adding the first second child reply
						} else {
							let children = document.createElement('ul');
							children.classList.add('children');
							children.innerHTML = data.comment;
		
							commentRespond.parentNode.insertBefore(children, commentRespond.nextSibling);
						}
					// Adding a first child reply to existing replies
					} else if (commentRespond.nextElementSibling && commentRespond.nextElementSibling.classList.contains('children')) {
						commentRespond.nextElementSibling.innerHTML += data.comment;
					// Adding the first child reply
					} else {
						let children = document.createElement('ul');
						children.classList.add('children');
						children.innerHTML = data.comment;

						commentRespond.parentNode.insertBefore(children, commentRespond.nextSibling);
					}
				} else {
					// Adding a base comment
					prevElement.innerHTML += data.comment;
				}
			}

			// Reset comment textarea
			commentRespond.querySelector('textarea').value = '';

			form.dispatchEvent(new CustomEvent('afterSubmit', { cancelable: true }));

			// Remove loading state
			btn.closest('p').classList.remove('loading');
		});
	}
}

FP_Utils.onReady(function() {
	new FP_Blog_Post();
});